/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 14:08:11
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-20 18:12:02
 */
import { Col, Form, Input, Modal, Row, Select } from 'antd'
import { useDispatch } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { RootDispatch } from '../../../../app/store'
import { DurgSaveform } from '../../../commoditySave/Durgsaveform'
import { MaterialSaveform } from '../../../commoditySave/Materialssaveform'
import styles from './RecipeItemInput.module.css'
import { ApparatusSaveform } from '../../../commoditySave/ApparatusSaveform'
import { NondurgSaveform } from '../../../commoditySave/Nondurgsaveform'

const { Option } = Select

export const AddCatalogueModal = (props: {
  isModalVisible: boolean
  medicalType?: any
  details?: any
  onOk: () => void
  onCancel: () => void
  batch?: (v?: any) => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  return (
    <Modal
      className={styles.modal}
      width={1850}
      title='新增目录'
      visible={props.isModalVisible}
      footer={null}
      destroyOnClose
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      {/* 1:药品 2:诊疗 3:耗材/材料	 */}
      {props?.medicalType == 0 ? (
        <DurgSaveform
          details={props?.details}
          materialCategory={props?.medicalType}
          flag={'/msfxFlag'}
          refresh={(v) => {
            props?.onOk()
            props?.batch && props?.batch(v)
          }}
        ></DurgSaveform>
      ) : props?.medicalType == 1 ? (
        <MaterialSaveform
          details={props?.details}
          materialCategory={props?.medicalType}
          flag={'/msfxFlag'}
          refresh={(v) => {
            props?.onOk()
            props?.batch && props?.batch(v)
          }}
        ></MaterialSaveform>
      ) : props?.medicalType == 2 ? (
        <ApparatusSaveform
          details={props?.details}
          materialCategory={props?.medicalType}
          flag={'/msfxFlag'}
          refresh={(v) => {
            props?.onOk()
            props?.batch && props?.batch(v)
          }}
        ></ApparatusSaveform>
      ) : props?.medicalType == 4 ? (
        <NondurgSaveform
          details={props?.details}
          materialCategory={props?.medicalType}
          flag={'/msfxFlag'}
          refresh={(v?: any) => {
            props?.onOk()
            props?.batch && props?.batch(v)
          }}
        ></NondurgSaveform>
      ) : (
        <></>
      )}
    </Modal>
  )
}
